module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kNmit"))).then(() => module.bundle.root('dsisd'));